import SerpContentRich from './SerpContentRich'

export default SerpContentRich
